// sagas.ts
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchRankFailure, FetchRankRequestAction, fetchRankSuccess } from './actions';
import api from '../../../api-new/http';
// import { appUrls } from '../../../api-new/urls';
import { FETCH_RANKS_REQUEST } from './constants';
import { appUrls } from '../../../api-new/urls';

export function* RankSaga(action: FetchRankRequestAction) {
    try {
        let contest = action.payload;
        const isEnded = new Date(contest?.endDateTime ?? 0) <= new Date();
        const isStarted = new Date(contest?.startDateTime ?? 0) <= new Date();
        let data: any;
        
        if (contest) {
            if(!isStarted){
                // console.log('Fetching latest rank...');
                const response = yield call(() => api.get(`${appUrls.tradeURL}/contests/latest`));
                contest = response.data.data;
                if (contest) data = yield call(() => api.get(`${appUrls.tradeURL}/contests/${contest.contestId}/rank/list`));
            }else if (!isEnded) {
                // console.log('Fetching current rank...');
                data = yield call(() => api.get(`${appUrls.tradeURL}/current-rank/contests/${contest.contestId}`));
            } else {
                // console.log('Fetching final rank...');
                data = yield call(() => api.get(`${appUrls.tradeURL}/contests/${contest.contestId}/rank/list`));
            }
           
            // console.log('RankSaga received:', data.data.data);
            // console.log('Contest of rank:', contest);
            if (data) {
                yield put(fetchRankSuccess({ topUsers: data.data.data, contest }));
            }
        }
     } catch (error) {
            yield put(fetchRankFailure(error as any));
        }
}

export function* rootRankSaga(): Generator {
    yield takeLatest(FETCH_RANKS_REQUEST, RankSaga);
}
